const initialState = {
  loading: false,
};

export default function invoicesListReducer(state = initialState, action) {
  switch (action.type) {
    case "INVOICES_FETCH_REQUESTED":
      return { ...state, loading: true };
    case "INVOICES_FETCHED":
      return {
        ...state,
        loading: false,
        invoices: action.result.data,
      };
    default:
      return state;
  }
}
